import { QueryKey } from '@fabric-ui/utils';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { useAvContext } from '../../../context/AvContextProvider';
import { dwQueryDefault, WidgetCategory } from '../types';

export const GET_DASHBOARD = gql`
  query findDashboardReportById($id: String!) {
    findDashboardReportById(id: $id) {
      id
      name
      description
      type
      accountId
      active
      intervalExpression
      deliveryConfig
      apps
      predefined
      globalFilters
      omitAliasPrefix
      dashboardReportPermission {
        type
        editors
        viewers
      }
      userPermissionType
      widgets {
        id
        type
        category
        binnedTimeBuckets
        historicalFilterMode
        drillDownHierarchy {
          fields {
            name
            alias
          }
        }
        requests {
          filter
          groupBy
          distinct
          source
          metricsFilterThreshold
          select {
            metrics {
              name
              alias
              conf
            }
            dims {
              name
              alias
              expression
            }
          }
          sorting {
            name
            dir
          }
          top {
            size
            groupOthers
            offset
          }
          projectionId {
            name
            builtIn
          }
          timeRange
        }
        definition {
          title
          coords
          custom
        }
      }
    }
  }
`;
export const useDashboard = ({ id, onSuccess = v => v, onError = e => e, enabled = true }) => {
  const { api } = useAvContext();
  return useQuery<any>({
    queryKey: [QueryKey.FindDashboardById, id],
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      api(GET_DASHBOARD, {
        options: { id },
        signal,
        onSuccess: ({ data, errors }) =>
          !errors &&
          onSuccess({
            ...data.findDashboardReportById,
            widgets: data.findDashboardReportById.widgets.map(widget => ({
              ...widget,
              drillDownHierarchy: { ...widget.drillDownHierarchy, activeIndex: 0 },
              requests: (widget.category === WidgetCategory.Text ? [dwQueryDefault] : widget.requests).map(request => ({
                ...request,
                select: {
                  ...request.select,
                  dims: request.select.dims || [],
                  metrics: request.select.metrics || [],
                },
              })),
            })),
          }),
        onError,
      }),
    enabled: !!id && enabled,
    gcTime: 0,
  });
};
